import React from 'react';
import { Folder, FolderOpen, Description } from '@mui/icons-material';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

const FileItem = ({ item, isSelected, onSelect, onDoubleClick }) => {
  const handleClick = () => {
    onSelect(item);
  };

  const handleDoubleClick = () => {
    if (item.directory) {
      onDoubleClick(item);
    }
  };

  return (
    <ListItem
      button = "true"
      selected={isSelected}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      sx={{
        '&.Mui-selected': {
          backgroundColor: 'primary.light',
        },
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <ListItemIcon>
        {item.directory ? (
          isSelected ? <Folder color="primary" /> : <FolderOpen color="primary" />
        ) : (
          <Description color="action" />
        )}
      </ListItemIcon>
      <ListItemText primary={item.name} secondary={!item.directory ? formatFileSize(item.size) : ''} />
    </ListItem>
  );
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export default FileItem;